import { BlobServiceClient } from "@azure/storage-blob";
import ASN from '../services/ASN'
import RestUtilities from "./Base";

export default class CoAUploader {
    static async amendAsnDetails(coAFileName: string, currentDate:string, coAFTPFileName:string, lp: string, header: any, asn: any) {

      const data  = {
        QvUpf: "Y",
        QvUpt:currentDate,
        QvCoa: coAFileName,
        QvCat: coAFTPFileName,
        Header: header
      }
      return ASN.uploadCoAData(lp, asn.lineID, header.costCenter, header.documentNumber, data);
    }

  static async amendLotDetails(coAFileName: string, currentDate: string, coAFTPFileName: string, lp: string, lotCodeId: string, harvestDate: string, sku:string) {

    const data = {
      QvUpf: "Y",
      QvUpt: currentDate,
      QvCoa: coAFileName,
      QvCat: coAFTPFileName
    }
    return this.uploadCoAData(lp, harvestDate, lotCodeId, sku, data);
  }

  //api/{lp}/lot/{harvestDate}/{lotCodeId}/coa
  static uploadCoAData(lp: string, harvestDate: string, lotCodeId: string, sku: string, data: any) {
    return RestUtilities.put(
      `api/${lp}/lot/${harvestDate}/${lotCodeId}/${sku}/coa`, data).then((response) => {
        return response
      })
  }

    static async sendCoA(file: File, harvestDate:string, lotCode: string, sku: any, lp:string, header: any, asn?: any, originalFileName?: string) {
      return new Promise(async (resolve, reject) => {
        const currentDate = new Date().toISOString().slice(-24).replace(/\D/g,'').slice(0, 14);
        const trimmedLP = lp.trim();
        let trimmedLot = lotCode.trim();
        if (trimmedLot.length > 20 ){
          trimmedLot = trimmedLot.substring(0, 19)
        }
        const trimmedSku = sku.trim();
        const asnNumber =`${asn?.documentNumber}`.trim();
        const blobName = originalFileName == null ? `${trimmedSku}+${trimmedLot}+${harvestDate}+${currentDate}.pdf` : originalFileName;
  
        const fileByteArray: any  = [];
        const reader = new FileReader();
        reader.onload = 
          async (evt: any) => {
            if (evt.target.readyState == FileReader.DONE) {
               const arrayBuffer = evt.target.result,
                   array = new Uint8Array(arrayBuffer);
               for (let i = 0; i < array.length; i++) {
                   fileByteArray.push(array[i]);
                }

              const uploadResponse = asn == null ?
                await RestUtilities.post("/api/lot/uploadCoA", {
                  coaFile: fileByteArray,
                  blobFolder: `${trimmedSku}-${lotCode}-${harvestDate}`,
                  storageFileName: blobName
                })
                :await RestUtilities.post("/api/asn/uploadCoA", {
                  coaFile: fileByteArray,
                  blobFolder: `${trimmedLP}-${asnNumber}`,
                  storageFileName: blobName
                },
                true);
          
                if (!uploadResponse.is_error) {
                  const amendResponse = asn == null ?
                    await this.amendLotDetails(blobName, currentDate, file.name.trim(), lp, lotCode, harvestDate, trimmedSku)
                    : await this.amendAsnDetails(blobName, currentDate, file.name.trim(), lp, header, asn);
                  if (amendResponse.ok) {
                    resolve(amendResponse);
                  } else {
                    resolve(blobName);
                  }
                } else {
                  resolve(uploadResponse.statusText);
                }
            }
          };
        reader.readAsArrayBuffer(file);
      });
    }
}
